<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryWorkSpaceList" style="width: 100.1%;">
      <template slot-scope="{row,index}" slot="actions">
            <span @click="doDelete(index)">
                <Button type="error" size="small" @click="workSpaceDelmodal = true" v-hasPermission="['permissionsConfigurationManagement:resourcePermission:delete_virtual_desktop']">{{ $t('alarms.common.delete') }}</Button>
            </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>

    <Modal v-model="workSpaceDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t('alarms.common.sureDelete') }} {{name}} {{ $t('alarms.common.what') }}?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="deleteWorkSpace()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
    var tableWorkSpace = {}
    export default {
        name: 'TableWorkSpace',
        data() {
            return {
                accountType: '',
                accountName: '',
                workspaceId:'',
                privateIp:'',
                current:1,
                dataTotal:0,
                pageSize:10,
                name: '',
                modalLoading: true,
                workSpaceDelmodal: false,
                isDisable: false,
                columns: [
                    {
                        title: this.$t('permission_configuration_management.group.accountName'),
                        key: 'accountName'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.accountType'),
                        key: 'accountTypeName'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.virtualDesktopID'),
                        key: 'workspaceId'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.name'),
                        key: 'name',
                        width: '120px'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.region'),
                        key: 'region'
                    },
                    {
                        title: this.$t('permission_configuration_management.group.privateIP'),
                        key: 'privateIp'
                    },
                    {
                        title: this.$t('alarms.common.status'),
                        key: 'stateName'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'actions'
                    }
                ],
                queryWorkSpaceList: [{
                    name: ''
                }]
            }
        },
        beforeCreate: function () {
            tableWorkSpace = this
        },
        methods: {
            // 点击备份目标的时候显示实例列表
            queryWorkspacesByGroupId: function () {
                eventBus.$on('accountName',function(val){
                    tableWorkSpace.accountName=val;
                })
                eventBus.$on('accountType',function(val){
                    tableWorkSpace.accountType=val;
                })
                eventBus.$on('workspaceId',function(val){
                    tableWorkSpace.workspaceId=val;
                })
                eventBus.$on('privateIp',function(val){
                    tableWorkSpace.privateIp=val;
                })
                tableWorkSpace.$api.workspace.queryWorkspacesByGroupId({
                    "groupId": this.$route.query.id,
                    "pageNum": this.current,
                    "pageSize": this.pageSize,
                    "workspaceId": tableWorkSpace.workspaceId,
                    "accountName": tableWorkSpace.accountName,
                    "accountType": tableWorkSpace.accountType,
                    "privateIp": tableWorkSpace.privateIp
                })
                .then(res => {
                    this.modalLoading = false
                    this.queryWorkSpaceList = res.data.records;
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                })
            },
            changePage: function(current){
                this.current=current;
                tableWorkSpace.queryWorkspacesByGroupId()
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableWorkSpace.queryWorkspacesByGroupId()
            },
            // 显示所有数据
            showAllWorkSpace: function () {
                tableWorkSpace.queryWorkspacesByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.name = this.queryWorkSpaceList[index].name
            },
            // 删除
            deleteWorkSpace: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                // 删除
                tableWorkSpace.$api.groupWorkspaceRelation.deleteByGroupIdAndWorkspaceId({
                    "groupId": this.$route.query.id,
                    "workspaceId": this.queryWorkSpaceList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if (lineIndex == 0 && ((this.current - 1) * this.pageSize + 1) == this.dataTotal) {
                            this.current = this.current - 1;
                        }
                        this.dataTotal = this.dataTotal - 1;
                        tableWorkSpace.queryWorkspacesByGroupId();
                        this.isDisable = false;
                        this.workSpaceDelmodal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableWorkSpace.vue